import type { SkeletonProps as MuiSkeletonProps } from '@mui/material';
import type { ValueOf } from '@kc-console/core';

export const SkeletonShapeSet = ['text', 'circle', 'rounded', 'rectangle'] as const;
export type SkeletonShape = ValueOf<typeof SkeletonShapeSet>;

export const SkeletonSizeSet = ['xs', 'sm', 'md', 'lg'] as const;
export type SkeletonSize = ValueOf<typeof SkeletonSizeSet>;

export const TEXT_SHAPE_SIZE_MAP: Record<SkeletonSize, number> = {
  xs: 10,
  sm: 12,
  md: 18,
  lg: 24,
} as const;

export const SHAPE_MAP: Record<SkeletonShape, MuiSkeletonProps['variant']> = {
  text: 'text',
  rectangle: 'rectangular',
  rounded: 'rounded',
  circle: 'circular',
} as const;
